import { isValueExist } from '@util';
import { MediaMixOptimizerService } from '@/services';
import { BehaviorSubject } from 'rxjs';
import memoize from 'lodash/memoize';
import { parseOptimizersToViews } from '../views/MediaMixOptimizer/util';

function getDefaultState() {
    return {
        isOptimizerMode: false,
        optimizers: [],
        optimizerCreated$: new BehaviorSubject({}),
        selectedTab: undefined,
        availableGoals: ['cpm', 'cpc', 'ctr', 'pixelRoas', 'cpi'],

        campaignsAll: [],

        isLoadingOptimizers: true,
        isOptimizerWidgetsLoading: true,
        optimizersToViews: [],
        optimizerWidgetIds: {},

        showGoalPanel: false,
        showGoalSecondPanel: false,
        showMMOOptionsPanel: false,
        showMMOOptionsSecondPanel: false,

        // TODO just to memo
        widgetIds: [
            'optimizer-budget',
            'optimizer-goalMetric',
            'optimizer-adTable',
            'optimizer-hidden-to-get-all-campaign-list',
        ],

        // temp
        newOptimizerName: '',
    };
}

export default {
    namespaced: 'true',
    state: getDefaultState(),
    mutations: {
        // temp
        setNewOptimizerName(state, payload) {
            state.newOptimizerName = payload;
        },
        setIsLoadingOptimizers(state, payload) {
            state.isLoadingOptimizers = payload;
        },
        setIsOptimizerWidgetsLoading(state, payload) {
            state.isOptimizerWidgetsLoading = payload;
        },
        updateOptimizerCampaigns(state, payload) {
            // console.log('updateOptimizerCampaigns:: ', payload);
        },
        setOptimizerWidgetIds(state, payload) {
            const { widget, widgetId } = payload;
            state.optimizerWidgetIds = Object.assign(
                {},
                state.optimizerWidgetIds,
                {
                    [widgetId]: widget,
                }
            );
        },
        setCampaignsAll(state, payload) {
            const { campaigns } = payload;
            state.campaignsAll = campaigns;
        },
        setIsOptimizerMode(state, payload = true) {
            state.isOptimizerMode = payload.flag;
        },
        setShowGoalPanel(state, payload = false) {
            state.showGoalPanel = payload;
        },
        setShowGoalSecondPanel(state, payload = false) {
            state.showGoalSecondPanel = payload;
        },
        setShowMMOOptionsPanel(state, payload = false) {
            state.showMMOOptionsPanel = payload;
        },
        setShowMMOOptionsSecondPanel(state, payload = false) {
            state.showMMOOptionsSecondPanel = payload;
        },
        setSelectedTab(state, payload = {}) {
            state.selectedTab = payload.selectedTab;
        },
        setOptimizers(state, payload = {}) {
            const parsed = R.map(
                ({
                    created_at,
                    goal_metric,
                    id,
                    last_optimized_at,
                    name,
                    options,
                    started_at,
                    status,
                    updated_at,
                    workspace_id,
                    currency,
                }) => {
                    return {
                        id,
                        currency: currency, // || 'USD',
                        name: name,
                        options: options || { campaigns: [] },
                        status: status, // || '',
                        goalMetric: goal_metric || '', //|| 'CPC',
                        updatedAt: updated_at || '',
                        createdAt: created_at || '',
                        startedAt: started_at,
                        lastOptimizedAt: last_optimized_at || '',
                        workspaceId: workspace_id,
                    };
                }
            )(payload.optimizers);
            state.optimizers = parsed;
        },
        addOptimizer(state, payload = {}) {
            state.optimizers = [...state.optimizers, payload.newOptimizer];
        },
    },
    actions: {
        getAvailableCampaigns({ commit }, payload) {
            const optimizerId = R.path(['optimizer', 'id'])(payload);

            commit('setIsOptimizerWidgetsLoading', true);

            return MediaMixOptimizerService.getAvailableCampaigns({
                optimizerId,
            })
                .then((data) => {
                    commit('setCampaignsAll', {
                        campaigns: R.prop('rows')(data),
                    });
                })
                .finally(() => {
                    commit('setIsOptimizerWidgetsLoading', false);
                });
        },
        removeOptimizersFromViews({ rootState, commit }) {
            let updatedViews = R.compose(
                R.filter(R.compose(R.not, R.propEq('type', 'optimizer'))),
                R.pathOr([], ['newDashboard', 'views'])
            )(rootState);

            commit('newDashboard/setViews', updatedViews, {
                root: true,
            });
        },
        getOptimizers({ commit, dispatch, rootState, state }, payload) {
            return MediaMixOptimizerService.getOptimizers()
                .then((data) => {
                    commit('setOptimizers', { optimizers: data });
                    return data;
                })
                .then(() => {
                    const { optimizers } = state;
                    const optimizersToViews =
                        parseOptimizersToViews(optimizers);

                    // console.log({
                    //     optimizersToViews,
                    // });

                    // TODO:: almost done, but think if I need another optimizer
                    // filter optimizers first => add optimizers
                    let updatedViews = R.compose(
                        R.concat(optimizersToViews),
                        R.filter(
                            R.compose(R.not, R.propEq('type', 'optimizer'))
                        ),
                        R.pathOr([], ['newDashboard', 'views'])
                    )(rootState);

                    commit('newDashboard/setViews', updatedViews, {
                        root: true,
                    });
                    return optimizers;
                });
        },
        createOptimizer({ commit, dispatch, state }, payload = {}) {
            const { name } = payload;
            return MediaMixOptimizerService.createOptimizer()
                .then((newOptimizer) => {
                    state.optimizerCreated$.next(newOptimizer);
                    return newOptimizer;
                })
                .then((newOptimizer) => {
                    newOptimizer = {
                        name: newOptimizer.name || name,
                        options: newOptimizer.options || {
                            campaigns: [],
                        },
                        status: newOptimizer.status || 'stopped',
                        ...newOptimizer,
                    };

                    // TODO delete
                    commit('addOptimizer', { newOptimizer });
                    return newOptimizer;
                });
        },
        updateOptimizer({ dispatch }, payload) {
            const { optimizer, keys } = payload;
            const dataToUpdate = R.pickAll(keys, optimizer);

            return MediaMixOptimizerService.updateOptimizer(dataToUpdate).then(
                (data) => {
                    dispatch('getOptimizers');
                }
            );
        },
        handleDelete({ dispatch }, payload) {
            const { item, deleteConfirmText, confirmDelete } = payload;
            // TODO filter with permission
            const { id, name } = item;

            confirmDelete({
                message: deleteConfirmText,
                value: name,
                cb: () => dispatch('deleteOptimizer', { optimizerId: id }),
            });
        },
        deleteOptimizer({ dispatch }, payload) {
            return MediaMixOptimizerService.deleteOptimizer(payload)
                .then(() => {
                    dispatch('getOptimizers');
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        startOptimizer({ dispatch, commit }, payload) {
            return MediaMixOptimizerService.startOptimizer(payload)
                .then((data) => {
                    dispatch('getOptimizers');
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        stopOptimizer({ dispatch, commit }, payload) {
            return MediaMixOptimizerService.stopOptimizer(payload)
                .then((data) => {
                    dispatch('getOptimizers');
                })
                .catch((e) => {
                    console.log(e);
                });
        },
    },
    getters: {
        /**
         * @deprecated
         */
        campaignsBeingOptimizedOnCurrent: (state, getters) => {
            const {
                campaignIdsBeingOptimizedOnCurrent: ids,
                campaignsCanBeOptimized,
            } = getters;

            const filtered = R.filter((campaign) =>
                ids.has(R.path(['id'])(campaign))
            )(campaignsCanBeOptimized);

            return filtered;
        },
        campaignsCanBeOptimized: (state, getters, rootState, rootGetters) => {
            const { campaignsAll } = state;
            // const {
            //     campaignIdsBeingOptimizedNOTOnCurrent: ids,
            //     // currentOptimizerCurrency,
            // } = getters;

            const isOk = R.identity;

            // TODO: every filter conditions moved to BE
            // const isActive = R.allPass([
            //     R.pathEq(['cells', 'status'], 'RUNNING'),
            //     R.pathEq(['active'], true),
            // ]);

            // const isCampaignNotOnOtherOptimizers = R.compose(
            //     R.not,
            //     ids.has.bind(ids),
            //     R.prop('id')
            // );

            // TODO getTable => cell
            // TODO getAvailableCampaigns => cells
            // const isDailyBudget = R.compose(
            //     R.gt(R.__, 0),
            //     R.pathOr(0, ['cell', 'budget', 'daily'])
            // );
            // const tableAdAccountsByChannelId =
            //     rootGetters['newDashboard/tableAdAccountsByChannelId'] || {};
            // const hasSameCurrency = (campaign) => {
            //     const { channelAdAccountId } = campaign;
            //     const adAccount =
            //         tableAdAccountsByChannelId[channelAdAccountId];
            //     if (adAccount === undefined) {
            //         console.warn(
            //             'Need to check:: while checking currency:: ',
            //             campaign
            //         );
            //         return false;
            //     }
            //     const campaignCurrency = R.path(['architecture', 'currency'])(
            //         adAccount
            //     );
            //     return R.equals(campaignCurrency, currentOptimizerCurrency);
            // };
            // const isDailyBudget = R.compose(
            //     R.not,
            //     R.path(['cell', 'budget', 'isLifeTimeBudget'])
            // );

            // const isBudgetCampaignLevel = R.T;
            // const isIdNotALL = R.compose(R.not, R.propEq('id', 'ALL'));

            const filtered = R.compose(
                R.clone,
                // R.map(campaign => (campaign.selected = false, campaign)),
                R.filter(
                    R.allPass([
                        isOk,
                        // isActive,
                        // isCampaignNotOnOtherOptimizers,
                        // hasSameCurrency,
                        // isDailyBudget,
                        // isBudgetCampaignLevel,
                        // isIdNotALL,
                    ])
                )
            )(campaignsAll);
            return filtered;
        },
        /**
         * @deprecated
         */
        campaignIdsBeingOptimizedNOTOnCurrent: (state, getters) => {
            const { optimizers } = state;
            const { currentOptimizerId } = getters;

            const campaignIds = R.compose(
                R.pluck('id'),
                R.flatten,
                R.map(R.pathOr([], ['options', 'campaigns'])),
                R.filter(R.compose(R.not, R.propEq('id', currentOptimizerId)))
            )(optimizers);

            return new Set(campaignIds);
        },
        campaignIdsBeingOptimizedOnCurrent(state, getters) {
            const { currentOptimizerOptions } = getters;
            const campaignIds = R.compose(
                R.pluck('id'),
                R.pathOr([], ['campaigns'])
            )(currentOptimizerOptions);
            return new Set(campaignIds);
        },
        currentOptimizerOptions(state, getters) {
            const { currentOptimizer } = getters;
            return R.propOr({}, 'options')(currentOptimizer);
        },
        currentOptimizerCurrency(state, getters) {
            const { currentOptimizer } = getters;
            return R.propOr('', 'currency')(currentOptimizer);
        },
        currentOptimizerId(state, getters) {
            const { currentOptimizer } = getters;
            return R.prop('id')(currentOptimizer);
        },
        currentOptimizer(state) {
            const { selectedTab, optimizers } = state;
            const currentOptimizer = R.compose(
                R.defaultTo({}),
                R.find(R.propEq('id', selectedTab))
            )(optimizers);

            return currentOptimizer;
        },
        mmoPhase: (state, getters) => {
            const {
                isCampaignSelected,
                isGoalSelected,
                isCurrentOptimizerRunning,
            } = getters;

            if (isCurrentOptimizerRunning) {
                return 3;
            } else if (!isGoalSelected) {
                return 0;
            } else if (!isCampaignSelected) {
                return 1;
            } else if (!isCurrentOptimizerRunning) {
                return 2;
            }
        },
        isCampaignSelected: (state, getters) => {
            const { campaignIdsBeingOptimizedOnCurrent: ids } = getters;
            return R.gt(ids.size, 0);
        },
        isGoalSelected: (state, getters) => {
            const { currentOptimizer } = getters;
            const flag = R.compose(
                isValueExist,
                R.path(['goalMetric'])
            )(currentOptimizer);
            return flag;
        },
        isCurrentOptimizerRunning: (state, getters) => {
            return R.compose(
                R.equals('running'),
                R.path(['currentOptimizer', 'status'])
            )(getters);
        },
        optimizersLength: memoize(
            R.pathOr(0, ['optimizers', 'length']),
            R.pathOr(0, ['optimizers', 'length'])
        ),
        campaigns: (state, getters) => {
            const { currentOptimizer } = getters;
            return R.path(['options', 'campaigns'])(currentOptimizer);
        },
    },
};
